<template>
<div class="dish-item" v-loading="postLoading"><div class="box">
    <YorkbbsImage aspect :src="imageList[0]|webpFormat(350)" borderRadius="4px" v-if="imageList.length>0"></YorkbbsImage>
    <div class="txt-title">{{ dish.name }}</div>
    <div class="thump-price">
        <div class="price">${{ dish.price }}</div>
        <div class="thump" @click="thumpFun">
            <i class="yk-zan" v-if="!hasThump"></i>
            <i class="yk-house_good active" v-else></i>
            
            {{ dish.thumbupCount }}
        </div>
    </div>
</div></div>
</template>
<script>
export default {
    name:'RecommendDishItem',
    props:{
        dish:{
            type:Object,
            default:{}
        }
    },
    computed:{
        imageList(){
            return this.dish.imageList||[];
        },
        hasThump(){
            return this.dish.hasGivenThumbUp == 1;
        },
        thumbupCount(){
            return this.dish.thumbupCount||0;
        }
    },
    data(){
        return {
            postLoading:false,
        }
    },
    methods:{
        async thumpFun(){
            this.postLoading = true;
            let result = await this.$axios.post('/comment/frontend/v1/give/thumbup/to/dish',{id:this.dish.id});
            this.postLoading = false;
            if( result.code == 0 ){
                if( this.hasThump ){
                    this.dish.hasGivenThumbUp = 0;
                    this.dish.thumbupCount--;
                }else{
                    this.dish.hasGivenThumbUp = 1;
                    this.dish.thumbupCount++;
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.dish-item{
   
    .txt-title{font-size: 16px; line-height: 30px; margin-top: 5px;}
    .thump-price{
        display: flex; justify-content: space-between; 
        .price{font-size: 14px; color: #999;}
        .thump{cursor: pointer;
            .active{color: #e43a3a;}
        }
    }
}
</style>